(function () {
  'use strict'

  var MODULE_NAME = 'thismoment.common.formly.config.messages'

  require('angular')
    .module(MODULE_NAME, [
      require('angular-formly'),
      require('angular-formly-templates-bootstrap')
    ])
    .constant('FormlyMessageStrings', {
      en: {
        'FORMLY.MESSAGE.ERROR': 'Error',
        'FORMLY.MESSAGE.MEDIA.IMAGE': 'image',
        'FORMLY.MESSAGE.MEDIA.VIDEO': 'video',
        'FORMLY.MESSAGE.MEDIA.DOCUMENT': 'document',
        'FORMLY.MESSAGE.REQUIRED': ' is required',
        'FORMLY.MESSAGE.SHORT': ' is too short',
        'FORMLY.MESSAGE.LONG': ' is too long',
        'FORMLY.MESSAGE.CHECKBOX.REQUIRED': 'Checkbox is required',
        'FORMLY.MESSAGE.EMAIL.INVALID': 'Please enter a valid email address'
      },
      es: {
        'FORMLY.MESSAGE.ERROR': 'Error',
        'FORMLY.MESSAGE.MEDIA.IMAGE': 'imagen',
        'FORMLY.MESSAGE.MEDIA.VIDEO': 'video',
        'FORMLY.MESSAGE.MEDIA.DOCUMENT': 'documento',
        'FORMLY.MESSAGE.REQUIRED': ' es requerido',
        'FORMLY.MESSAGE.SHORT': ' es demasiado corto',
        'FORMLY.MESSAGE.LONG': ' es demasiado largo',
        'FORMLY.MESSAGE.CHECKBOX.REQUIRED': 'Por favor marque la casilla',
        'FORMLY.MESSAGE.EMAIL.INVALID': 'Por favor, introduce una dirección de correo electrónico válida'
      },
      fr: {
        'FORMLY.MESSAGE.ERROR': 'Erreur',
        'FORMLY.MESSAGE.MEDIA.IMAGE': 'image',
        'FORMLY.MESSAGE.MEDIA.VIDEO': 'vidéo',
        'FORMLY.MESSAGE.MEDIA.DOCUMENT': 'document',
        'FORMLY.MESSAGE.REQUIRED': ' est requis',
        'FORMLY.MESSAGE.SHORT': ' est trop court',
        'FORMLY.MESSAGE.LONG': ' est trop long',
        'FORMLY.MESSAGE.CHECKBOX.REQUIRED': 'Veuillez cocher la case',
        'FORMLY.MESSAGE.EMAIL.INVALID': "S'il vous plaît, mettez une adresse email valide"
      },
      jp: {
        'FORMLY.MESSAGE.ERROR': 'エラー',
        'FORMLY.MESSAGE.MEDIA.IMAGE': '画像',
        'FORMLY.MESSAGE.MEDIA.VIDEO': 'ビデオ',
        'FORMLY.MESSAGE.MEDIA.DOCUMENT': '書類',
        'FORMLY.MESSAGE.REQUIRED': '必要とされる',
        'FORMLY.MESSAGE.SHORT': '短すぎる',
        'FORMLY.MESSAGE.LONG': '長すぎます',
        'FORMLY.MESSAGE.CHECKBOX.REQUIRED': 'チェックボックスをオンにしてください',
        'FORMLY.MESSAGE.EMAIL.INVALID': '有効なメールアドレスを入力してください'
      },
      it: {
        'FORMLY.MESSAGE.ERROR': 'Errore',
        'FORMLY.MESSAGE.MEDIA.IMAGE': 'immagine',
        'FORMLY.MESSAGE.MEDIA.VIDEO': 'video',
        'FORMLY.MESSAGE.MEDIA.DOCUMENT': 'documento',
        'FORMLY.MESSAGE.REQUIRED': ' è richiesto',
        'FORMLY.MESSAGE.SHORT': ' è troppo corto',
        'FORMLY.MESSAGE.LONG': ' è troppo lungo',
        'FORMLY.MESSAGE.CHECKBOX.REQUIRED': 'Si prega di selezionare la casella',
        'FORMLY.MESSAGE.EMAIL.INVALID': 'Inserire un indirizzo mail valido'
      }
    })
    .run(MessagesConfig)

  MessagesConfig.$inject = ['formlyConfig', 'formlyValidationMessages', 'FormlyMessageStrings', 'SdkConfig']
  function MessagesConfig (formlyConfig, formlyValidationMessages, FormlyMessageStrings, SdkConfig) {
    formlyConfig.extras.errorExistsAndShouldBeVisibleExpression = 'fc.$touched || form.$submitted'
    formlyValidationMessages.messages.required = getRequiredMessage
    formlyValidationMessages.messages.minlength = getMinlengthMessage
    formlyValidationMessages.messages.maxlength = getMaxlengthMessage
    formlyValidationMessages.messages.email = getEmailMessage

    // note that we can't just SdkConfig.get() lang once as it changes whereas this is run onc
    // ...I suppose some listeners etc could do the job, but I digress
    function getRequiredMessage ($viewValue, $modelValue, scope) {
      if (scope.options.type === 'checkbox') {
        return wrapErrorMessage(FormlyMessageStrings[SdkConfig.get('language')]['FORMLY.MESSAGE.CHECKBOX.REQUIRED'])
      } else if (scope.options.type === 'file-upload') {
        var allowedTypes = []
        angular.forEach(scope.uploader.useFilters, (mediaType) => {
          switch (mediaType) {
            case 'restrictVideo':
              allowedTypes.push(FormlyMessageStrings[SdkConfig.get('language')]['FORMLY.MESSAGE.MEDIA.VIDEO'])
              break
            case 'restrictImage':
              allowedTypes.push(FormlyMessageStrings[SdkConfig.get('language')]['FORMLY.MESSAGE.MEDIA.IMAGE'])
              break
            case 'restrictDoc':
              allowedTypes.push(FormlyMessageStrings[SdkConfig.get('language')]['FORMLY.MESSAGE.MEDIA.DOCUMENT'])
              break
          }
        })
        if (allowedTypes.length === 1) {
          return wrapErrorMessage('Upload your ' + allowedTypes[0] + FormlyMessageStrings[SdkConfig.get('language')]['FORMLY.MESSAGE.REQUIRED'])
        } else if (allowedTypes.length === 2) {
          return wrapErrorMessage('Upload your ' + allowedTypes[0] + ' or ' + allowedTypes[1] + FormlyMessageStrings[SdkConfig.get('language')]['FORMLY.MESSAGE.REQUIRED'])
        } else {
          return wrapErrorMessage('Upload your ' + allowedTypes[0] + ', ' + allowedTypes[1] + ', or ' + allowedTypes[2] + FormlyMessageStrings[SdkConfig.get('language')]['FORMLY.MESSAGE.REQUIRED'])
        }
      } else {
        return wrapErrorMessage(scope.to.label.replace(/<(.|\n)*?>/g, '') + FormlyMessageStrings[SdkConfig.get('language')]['FORMLY.MESSAGE.REQUIRED'])
      }
    }
    function getMinlengthMessage ($viewValue, $modelValue, scope) {
      return wrapErrorMessage(scope.to.label + FormlyMessageStrings[SdkConfig.get('language')]['FORMLY.MESSAGE.SHORT'])
    }
    function getMaxlengthMessage ($viewValue, $modelValue, scope) {
      return wrapErrorMessage(scope.to.label + FormlyMessageStrings[SdkConfig.get('language')]['FORMLY.MESSAGE.LONG'] + ': ' + $viewValue.length + '/' + scope.to.maxlength.toString())
    }
    function getEmailMessage ($viewValue, $modelValue, scope) {
      return wrapErrorMessage(FormlyMessageStrings[SdkConfig.get('language')]['FORMLY.MESSAGE.EMAIL.INVALID'])
    }
    function wrapErrorMessage (message) {
      return FormlyMessageStrings[SdkConfig.get('language')]['FORMLY.MESSAGE.ERROR'] + ': ' + message
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/common/formly/config/messages.js